"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingDetailsUserDto = instanceOfListingDetailsUserDto;
exports.ListingDetailsUserDtoFromJSON = ListingDetailsUserDtoFromJSON;
exports.ListingDetailsUserDtoFromJSONTyped = ListingDetailsUserDtoFromJSONTyped;
exports.ListingDetailsUserDtoToJSON = ListingDetailsUserDtoToJSON;
exports.ListingDetailsUserDtoToJSONTyped = ListingDetailsUserDtoToJSONTyped;
/**
 * Check if a given object implements the ListingDetailsUserDto interface.
 */
function instanceOfListingDetailsUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function ListingDetailsUserDtoFromJSON(json) {
    return ListingDetailsUserDtoFromJSONTyped(json, false);
}
function ListingDetailsUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'],
        'isVerified': json['isVerified'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
    };
}
function ListingDetailsUserDtoToJSON(json) {
    return ListingDetailsUserDtoToJSONTyped(json, false);
}
function ListingDetailsUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'isVerified': value['isVerified'],
        'avatar': value['avatar'],
    };
}
